import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { AwardFiles } from 'containers/pages'
import { AWARD_FILE_CATEGORY_TYPES } from '../../../constants/enums'

export default class ActivityFiles extends Component {
  static propTypes = {
    isReadOnly: PropTypes.bool,
    activity: PropTypes.object
  }

  render() {
    const { activity, isReadOnly } = this.props

    return (
      <AwardFiles
        sectionId={get(activity, 'activitySection.value')}
        readOnly={isReadOnly}
        category={AWARD_FILE_CATEGORY_TYPES.activity.id}
        {...this.props}
      />
    )
  }
}
